import { Box, Button, Flex, useToast } from "@chakra-ui/react";
import React from "react";
import { CInput } from "../common";
import { useFormik } from "formik";
import { clientTechnicianSchema } from "../../utils/schemas";
import { ClientTechnicianModel } from "../../services";

export default function AddTechnicianForm({ fetchTechs }) {
  const toast = useToast();

  const onAddTech = async (values) => {
    try {
      await ClientTechnicianModel.linkTech(values.identifier);
      fetchTechs();
      formik.resetForm();
      toast({
        description: "Technician added successfully!",
        status: "success",
        isClosable: true,
      });
    } catch (error) {
      toast({
        description:
          error.response?.status === 404
            ? "User not found!"
            : error.response?.status === 409
            ? "User already added!"
            : "Something went wrong!",
        status: "error",
        isClosable: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      identifier: "",
    },
    validationSchema: clientTechnicianSchema,
    onSubmit: onAddTech,
  });

  return (
    <Box>
      <Flex gap={2}>
        <CInput
          name="identifier"
          placeholder="Enter Email or User ID"
          value={formik.values.identifier}
          onChange={formik.handleChange}
          disabled={formik.isSubmitting}
        />
        <Button
          bgColor="black"
          borderRadius="lg"
          fontWeight="medium"
          py="4"
          isLoading={formik.isSubmitting}
          isDisabled={!formik.dirty}
          onClick={formik.handleSubmit}
        >
          Add New
        </Button>
      </Flex>
    </Box>
  );
}
